export default "__VITE_ASSET__ClMA2ILk__"